import { AppButton } from 'components';
import {
  AppModal,
  AppModalBody,
  AppModalFooter,
  AppModalHeader,
} from 'components/molecules/Modal/AppModal';
import useDeleteQuiz from 'hooks/API/DELETE/useDeleteQuiz';
import useToaster from 'hooks/useToaster';

function QuizDeleteModal({ modalConfig = {}, closeModal }) {
  const { mutate, isLoading, isError } = useDeleteQuiz();
  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  function deleteQuiz() {
    mutate(modalConfig.data ?? {});
    closeModal();
  }

  return (
    <AppModal open={modalConfig.show} closeModal={closeModal} size="sm">
      <AppModalHeader>Delete Quiz</AppModalHeader>
      <AppModalBody>Do you want to delete this quiz?</AppModalBody>
      <AppModalFooter>
        <AppButton variantClass="btn btn-success mx-4" onClick={deleteQuiz}>
          YES
        </AppButton>
        <AppButton variantClass="btn btn-danger mx-4" onClick={closeModal}>
          NO
        </AppButton>
      </AppModalFooter>
    </AppModal>
  );
}

export default QuizDeleteModal;
